import React, {useEffect, useState} from 'react';
import ActionButton from '../../../library/input/buttons/button/SarasButton'
import { useSelector } from 'react-redux';
import useFormApi from '../docAutomation/useFormApi'
import SarasMenu from '../../../library/repeater/menu/SarasMenu';
import InsightLayoutRow from './InsightLayoutRow';
import { buildLayoutConfig } from './insights_functions';
import InsightsView from './InsightsView';
import insightViewMap from './Index'
import SarasDynamicGrid from '../../../library/container/grid/SarasDynamicGrid';
import SarasDateRangePicker from '../../../library/input/datePicker/SarasDateRangePicker';
import GridMenu from '../../../layout/main/components/GridMenu';

const InsightsContainer = ({deviceInfo}) => {
    const [currentLayoutKey, setCurrentLayoutKey] = useState("");
    const [currentLayoutConfig, setCurrentLayoutConfig] = useState(null);
    const [layoutList, setLayoutList] = useState(null);
    const [currentLayout, setCurrentLayout] = useState(null);
    const [sycnhOption, setSycnhOption] = useState('');
    const [sycnhReload, setSycnhReload] = useState(0);
    const [sycnhDate, setSycnhDate] = useState({
      startDate: null,
      endDate: null,
    });

    const formApi = useFormApi();

    const serverAttributes = useSelector(state => state.auth.server);

    const viewMap = {...insightViewMap};
    
    const loadLayout = () => {
        if(serverAttributes.InsightsActive === 1 && !layoutList && currentLayoutKey !== "-1") {
            // setIsLoadingInsight(1);
            let layoutAction = { actionId: "get", actionName: "appInsight", actionParam: {'content-type':'insight-layout-current'}, containerKey:""};
            formApi.runGenericAction(layoutAction, "appInsight", null, null, null, "", "", 0, onLayoutSuccess);
        }
    };

    useEffect(loadLayout, [serverAttributes, layoutList, currentLayoutKey]);

    const onLayoutSuccess = (action, containerKey, rowKey, headerKey, response) => {
        // console.log("layout response", response);

        //Get layout list
        //Get current layout
    
        if(response){
            setCurrentLayoutKey(response.mainViewData.headerRows.config.dataList.currentLayoutKey);

            if(response.mainViewData.headerRows.config.dataList.currentLayoutKey !== "-1")
            {
                setLayoutList(response.mainViewData.childViews.layoutListView);
                setCurrentLayout(response.mainViewData.childViews.layoutView);

                //read the layout config and set it in the state
                setCurrentLayoutConfig(buildLayoutConfig(response.mainViewData.childViews.layoutView.headerRows.config.dataList.currentLayoutConfig));
            }
        }

        // setIsLoadingInsight(0);
    }
    
    const onLayoutSelect = (e, index) => {
        let layoutRowClicked = layoutList.viewRows[Object.keys(layoutList.viewRows)[index]];
        if (!layoutRowClicked) return;
        
        // console.log("fav row object", favRowClicked, favList);
        setCurrentLayoutKey(layoutRowClicked.dataList.lk);

        //fire api request to load new layout
        let layoutAction = { actionId: "get", actionName: "appInsight", actionParam: {
            'content-type':'insight-layout-switch',
            'insight-layout-key': layoutRowClicked.dataList.lk
        }, containerKey: ""};
        formApi.runGenericAction(layoutAction, "appInsight", null, null, null, "", "", 0, onLayoutSuccess);
    }

    const onChangeOptionClick = (value) => {
        setSycnhOption(value);
    }

    const onReloadClick = () => {
        setSycnhReload(sycnhReload + 1);
    }

    const onDateCriteriaChange = (newDate) => {
        setSycnhDate(newDate);
    }

    const renderInsights = () => {
        // insights are needed but not yet loaded, so render nothing and wait for it
        if(!layoutList || !currentLayoutConfig) return null;

        return (
            <div className='uiInsightLayout'>
                <SarasDynamicGrid layoutConfig={currentLayoutConfig} deviceInfo={deviceInfo}>
                    {
                        Object.values(currentLayout.viewRows).map((row, index)=>(
                            <div key={row.dataList.vk} style={{ overflow: "hidden", width: "100%", height: "100%", margin: 0, padding: 0, boxSizing: "border-box" }}>
                                <InsightsView viewData={row} key={index} viewMap={viewMap} 
                                    insightKey={row.dataList.vk}
                                    loadOnVisible={true}
                                    sycnhOption={sycnhOption} 
                                    onOptionChanged={onChangeOptionClick} 
                                    sycnhReload={sycnhReload} 
                                    sycnhDate={sycnhDate}
                                    deviceInfo={deviceInfo}
                                    // onCriteriaChanged={onCriteriaChange}
                                />
                            </div>
                        ))
                    }
                </SarasDynamicGrid>
            </div>
        )
    }

    const renderInsightSelector = () => {
        if(!layoutList || !currentLayoutConfig) return null;

        return (
            <SarasMenu menuTrigger={
                <ActionButton ksc="i" 
                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0} // Hide text on mobile
                    starIcon="insight" starIconClassName="uiBrandColor1" 
                    endIcon="arrowmenu" endIconClassName="uiBrandColor1"
                    className={'uiSpacerL2 uiContentCenter uiButtonAppText2 saras-tour-insight-action-switch'}>
                    <span className='uiAppText2Compliment'>Select Insights</span>
                </ActionButton>
            }
            dataList={Object.values(layoutList.viewRows)} 
            menuItem={InsightLayoutRow} onSelection={onLayoutSelect}></SarasMenu>
        )
    }

    // console.log ("device info", deviceInfo);

    //server attributes are still not available, hence render nothing and wait for it
    if(! serverAttributes || serverAttributes.AppVersion === "") return null;

    //insights are not active on the server, hence render menu
    if(serverAttributes.InsightsActive !== 1) return <GridMenu />;

    //insights are needed but not yet loaded, so render nothing and wait for it
    if(!layoutList || !currentLayoutConfig) return null;

    return (
        <div className="uiInsightContainer">
            <div className='uiInsightList'>
                <div className={`uiInsightHeader saras-tour-insight`}>
                    <div className='uiTitle'>
                        {currentLayoutKey && layoutList && layoutList.viewRows[currentLayoutKey] ? layoutList.viewRows[currentLayoutKey].dataList.ln : 'Default Layout'}
                    </div>
                    <div className={`uiInsightAction uiFlexBox`}>
                        <SarasDateRangePicker 
                            onlyIcon={deviceInfo.activateMobileView ? 1 : 0} // Hide text on mobile
                            buttonClassName={`uiContentCenter uiButtonAppText2 saras-tour-insight-action-date `}
                            titleClassName="uiAppText2Compliment"
                            value={sycnhDate}
                            onChange={onDateCriteriaChange}/>
                        <ActionButton ksc="r" 
                            starIcon="refresh" starIconClassName="uiBrandColor1" 
                            onlyIcon={deviceInfo.activateMobileView ? 1 : 0} // Hide text on mobile
                            onClick={onReloadClick}
                            className={`uiContentCenter uiButtonAppText2 saras-tour-insight-action-refresh`}>
                            <span className='uiAppText2Compliment'>Refresh All</span>
                        </ActionButton>
                        {renderInsightSelector()}
                    </div>
                </div>
            </div>
            {renderInsights()}
        </div>
    )
}

export default InsightsContainer;
